import { render } from "./EditSalesOrderItemView.vue?vue&type=template&id=a38ccbbe"
import script from "./EditSalesOrderItemView.vue?vue&type=script&lang=js"
export * from "./EditSalesOrderItemView.vue?vue&type=script&lang=js"

import exportComponent from "/home/websites/repositories/macgear-scanner/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__